import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { Cards } from "./components/Cards/Cards"
import { Cooperation } from "./components/Cooperation/Cooperation"
import { Hero } from "./components/Hero/Hero"
import { List } from "./components/List/List"
import { Subscription } from "./components/Subscription/Subscription"

const Procurements: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout headerTheme="onDark" title={t("page.procurements")}>
      <Hero />
      <List />
      <Subscription />
      <Cooperation />
      <Cards />
    </Layout>
  )
}

export default Procurements
